module.exports = __webpack_public_path__ + "img/sidebarlogo.39bfcf73.png";